import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import Hoot from "../../Hoot";
import ClickAllRefreshButtons from "../../ClickAllRefreshButtons";
import { Avatar } from "@mui/material";
import { toast } from "react-toastify";

const SMS_UNIT_PRICE = 13.99;
const MIN_SMS = 1000;

const styles = `
.pretty-modal .modal-dialog{
  max-width: 720px;
}
@media (max-width: 768px){
  .pretty-modal .modal-dialog{ max-width: 96vw; }
}
.pretty-modal .modal-content{
  border-radius: 18px;
  border: 1px solid rgba(226,232,240,.95);
  box-shadow: 0 30px 90px rgba(2,6,23,.22);
  overflow: hidden;
}
.pretty-modal .modal-header{
  border-bottom: 1px solid rgba(226,232,240,.9);
  background:
    radial-gradient(1000px 260px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
    radial-gradient(900px 240px at 95% 0%, rgba(124,58,237,.12), transparent 55%),
    #ffffff;
  padding: 14px 16px;
}
.pretty-modal .modal-title{
  font-weight: 650;
  color: #0f172a;
  font-size: 1rem;
}

.pretty-modal .modal-body{
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, rgba(248,250,252,.75), #ffffff 40%);
}
.body-scroll{ 
  overflow-y: auto;
  padding-right: 4px;
}

.pretty-modal .modal-footer{
  border-top: 1px solid rgba(226,232,240,.9);
  padding: 12px 16px;
  background: #ffffff;
}

.header-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  flex-wrap:wrap;
}
.header-left{
  display:flex;
  align-items:center;
  gap:12px;
}

.avatar-wrap{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(91,92,255,.10);
  border: 1px solid rgba(91,92,255,.18);
  display:grid;
  place-items:center;
}

.title-sub{
  margin-top:2px;
  font-size: .8rem;
  color: #64748b;
  font-weight: 500;
}

.cardlet{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(226,232,240,.95);
  border-radius: 16px;
  padding: 10px 12px;
}
.cardlet-title{
  font-size: .78rem;
  color:#64748b;
  font-weight: 600;
  display:flex;
  align-items:center;
  gap:8px;
  margin-bottom: 8px;
}

.form-label{
  font-size: .78rem !important;
  color: #475569 !important;
  font-weight: 600 !important;
  margin-bottom: 6px !important;
}
.form-control, .form-select{
  border-radius: 12px !important;
  border-color: rgba(226,232,240,.95) !important;
  padding-top: .55rem !important;
  padding-bottom: .55rem !important;
}
.form-control:focus, .form-select:focus{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}

.helper{
  font-size: .74rem;
  color:#64748b;
  margin-top: 6px;
}

.summary{
  border: 1px solid rgba(226,232,240,.95);
  background: rgba(248,250,252,.85);
  border-radius: 16px;
  padding: 10px 12px;
  display:flex;
  gap:12px;
  align-items:center;
}
.summary-title{
  font-weight: 650;
  color:#0f172a;
  font-size:.95rem;
  margin:0;
}
.summary-sub{
  color:#64748b;
  font-size:.78rem;
  margin-top:4px;
}

.money-row{
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  flex-wrap:wrap;
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid rgba(226,232,240,.95);
  background: #ffffff;
}
.money-title{
  color:#475569;
  font-size:.78rem;
  font-weight:650;
}
.money-value{
  font-weight:700;
  color:#16a34a;
  font-size:1rem;
}

.actions{
  display:flex;
  justify-content:flex-end;
  gap:10px;
  flex-wrap:wrap;
}
.btn-soft{
  border-radius: 999px !important;
  border: 1px solid rgba(226,232,240,.95) !important;
  background: #fff !important;
}
.btn-primary{
  border-radius: 999px !important;
}

.req{
  color:#ef4444;
  font-weight:700;
}
`;

// react-select alinhado ao mesmo design do modal
const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: 12,
    borderColor: state.isFocused ? "rgba(91,92,255,.45)" : "rgba(226,232,240,.95)",
    boxShadow: state.isFocused ? "0 0 0 .2rem rgba(91,92,255,.15)" : "none",
    minHeight: 42,
    paddingLeft: 2,
  }),
  valueContainer: (base) => ({ ...base, padding: "6px 10px" }),
  placeholder: (base) => ({ ...base, color: "#94a3b8", fontSize: ".86rem" }),
  menu: (base) => ({ ...base, borderRadius: 14, overflow: "hidden", zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "rgba(91,92,255,.12)"
      : state.isFocused
      ? "rgba(148,163,184,.15)"
      : "#fff",
    color: "#0f172a",
    padding: "10px 10px",
  }),
};

function safeLogoUrl(logo) {
  if (!logo) return null;
  // mantém teu padrão sv.eduall.pt
  if (String(logo).startsWith("http")) return logo;
  return "https://sv.eduall.pt/" + logo;
}

function formatAOA(value) {
  const n = Number(value || 0);
  return n.toLocaleString("pt-PT");
}

function RegisterSmsPaymentModal({ toggle_btn, code }) {
  const [show, setShow] = useState(false);

  const [institutions, setInstitutions] = useState([]);
  const [institutionsLoading, setInstitutionsLoading] = useState(false);
  const [institutionsError, setInstitutionsError] = useState(null);

  const [formData, setFormData] = useState({
    institution_code: code || "",
    selectedInstitution: null,
    total_sms: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [totalPrice, setTotalPrice] = useState(0);

  const openModal = () => setShow(true);

  const closeModal = () => {
    if (loading) return;
    setShow(false);
    setError(null);
    setLoading(false);

    setInstitutionsError(null);

    setTotalPrice(0);
    setFormData((prev) => ({
      institution_code: code || "",
      selectedInstitution: code ? prev.selectedInstitution : null,
      total_sms: "",
    }));
  };

  // carregar instituições quando abrir modal (e sempre que code mudar)
  useEffect(() => {
    if (!show) return;

    const fetchInstitutions = async () => {
      try {
        setError(null);
        setInstitutionsError(null);
        setInstitutionsLoading(true);

        const res = await axios.get(Hoot() + "institutes", { withCredentials: true });
        const list = res.data || [];
        setInstitutions(list);

        // se vier code, auto-seleciona
        if (code) {
          const selected = list.find((inst) => inst.code === code);
          if (selected) {
            setFormData((prev) => ({
              ...prev,
              selectedInstitution: selected,
              institution_code: selected.code,
            }));
          }
        }
      } catch (e) {
        setInstitutions([]);
        setInstitutionsError("Erro ao carregar instituições.");
      } finally {
        setInstitutionsLoading(false);
      }
    };

    fetchInstitutions();
  }, [show, code]);

  // se total_sms muda, recalcula o preço
  useEffect(() => {
    const sms = Number(formData.total_sms || 0);
    if (sms >= MIN_SMS) setTotalPrice(sms * SMS_UNIT_PRICE);
    else setTotalPrice(0);
  }, [formData.total_sms]);

  const institutionOptions = useMemo(() => {
    return (institutions || []).map((inst) => ({
      value: inst.code,
      label: (
        <div className="d-flex align-items-center gap-2">
          <Avatar
            variant="rounded"
            src={safeLogoUrl(inst.logo)}
            alt={inst.name}
            sx={{ width: 44, height: 44, borderRadius: 3 }}
          />
          <div>
            <div style={{ fontWeight: 650, fontSize: ".9rem", color: "#0f172a" }}>
              {inst.name}
            </div>
            <div style={{ fontSize: ".78rem", color: "#64748b" }}>NIF: {inst.nif}</div>
          </div>
        </div>
      ),
      data: inst,
    }));
  }, [institutions]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const { institution_code, total_sms } = formData;
    const sms = Number(total_sms || 0);

    if (!institution_code || sms < MIN_SMS) {
      toast.warning(`Preencha os campos corretamente (mínimo de ${MIN_SMS} SMS).`);
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        Hoot() + "sms-payments",
        { totalSMS: sms, instituteCode: institution_code },
        { withCredentials: true }
      );

      toast.success("Pagamento de SMS realizado com sucesso!");
      setShow(false);
      ClickAllRefreshButtons();
    } catch (err) {
      setError(err?.response?.data?.msg || "Erro ao processar pagamento.");
    } finally {
      setLoading(false);
    }
  };

  const selected = formData.selectedInstitution;
  const selectedLogo = selected ? safeLogoUrl(selected.logo) : null;

  return (
    <>
      <style>{styles}</style>

      <div onClick={openModal} style={{ display: "inline-block" }}>
        {toggle_btn}
      </div>

      <Modal
        show={show}
        onHide={closeModal}
        centered
        backdrop="static"
        keyboard={!loading}
        className="pretty-modal"
      >
        <Modal.Header closeButton={!loading}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              {/*  igual ao modal de contactos */}
              <div className="avatar-wrap">
                <i
                  className="bi bi-chat-left-text"
                  style={{ color: "#5b5cff", fontSize: 18 }}
                />
              </div>

              <div>
                <div style={{ fontWeight: 650 }}>Pagar créditos SMS</div>
                <div className="title-sub">
                  Selecione a instituição e informe a quantidade de SMS.
                </div>
              </div>
            </div>

            {selectedLogo ? (
              <Avatar
                variant="rounded"
                src={selectedLogo}
                sx={{ width: 44, height: 44, borderRadius: 3 }}
              />
            ) : null}
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {error ? (
              <Alert variant="danger" className="mb-3" style={{ borderRadius: 14 }}>
                {error}
              </Alert>
            ) : null}

            {!error && institutionsError ? (
              <Alert variant="danger" className="mb-3" style={{ borderRadius: 14 }}>
                {institutionsError}
              </Alert>
            ) : null}

            <Form id="sms-payment-form" onSubmit={handleSubmit}>
              {/* Seleção de instituição (só aparece se não vier code) */}
              {!code ? (
                <div className="cardlet mb-3">
                  <div className="cardlet-title">
                    <i className="bi bi-building" />
                    Instituição
                  </div>

                  <Form.Group>
                    <Form.Label>
                      Selecionar instituição <span className="req">*</span>
                    </Form.Label>

                    <Select
                      options={institutionOptions}
                      styles={selectStyles}
                      onChange={(option) => {
                        setFormData((prev) => ({
                          ...prev,
                          institution_code: option?.value || "",
                          selectedInstitution: option?.data || null,
                        }));
                      }}
                      placeholder={
                        institutionsLoading ? "A carregar instituições..." : "Selecionar instituição..."
                      }
                      isDisabled={loading || institutionsLoading}
                      isLoading={institutionsLoading}
                    />

                    <div className="helper">
                      Procure pelo nome e selecione a instituição correta.
                    </div>
                  </Form.Group>
                </div>
              ) : null}

              {/* Summary (igual vibe ao modal de contactos) */}
              {selected ? (
                <div className="summary mb-3">
                  <Avatar
                    variant="rounded"
                    src={selectedLogo}
                    sx={{ width: 52, height: 52, borderRadius: 4 }}
                  />
                  <div style={{ flex: 1 }}>
                    <div className="summary-title">{selected.name}</div>
                    <div className="summary-sub">NIF: {selected.nif}</div>
                    <div className="summary-sub">Código: {selected.code}</div>
                  </div>
                </div>
              ) : null}

              {/* Quantidade */}
              <div className="cardlet mb-3">
                <div className="cardlet-title">
                  <i className="bi bi-123" />
                  Quantidade
                </div>

                <Form.Group>
                  <Form.Label>
                    Número de SMS ({SMS_UNIT_PRICE} AOA / SMS) <span className="req">*</span>
                  </Form.Label>

                  <Form.Control
                    type="number"
                    min={MIN_SMS}
                    value={formData.total_sms}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, total_sms: e.target.value }))
                    }
                    placeholder={`Mínimo de ${MIN_SMS} SMS`}
                    disabled={loading}
                  />

                  <div className="helper">
                    A quantidade mínima é {MIN_SMS}. O total é calculado automaticamente.
                  </div>
                </Form.Group>
              </div>

              {/* Total */}
              <div className="money-row mb-2">
                <div>
                  <div className="money-title">Total a pagar</div>
                  <div style={{ fontSize: ".76rem", color: "#64748b" }}>
                    {totalPrice > 0
                      ? `${Number(formData.total_sms).toLocaleString("pt-PT")} SMS`
                      : "Informe a quantidade"}
                  </div>
                </div>

                <div className="money-value">{formatAOA(totalPrice)} AOA</div>
              </div>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="actions" style={{ width: "100%" }}>
            <Button
              type="button"
              variant="outline-secondary"
              className="btn-soft"
              onClick={closeModal}
              disabled={loading}
            >
              Cancelar
            </Button>

            <Button
              type="submit"
              variant="primary"
              form="sms-payment-form"
              disabled={
                loading ||
                institutionsLoading ||
                !formData.institution_code ||
                Number(formData.total_sms || 0) < MIN_SMS
              }
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A processar...
                </>
              ) : (
                "Efetuar pagamento"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RegisterSmsPaymentModal;
